// extracted by mini-css-extract-plugin
export default {"wrapperSearch":"SearchBox_wrapperSearch__pcEkt"};